import styled from '@emotion/styled';
import { Colors } from '../../../../colors';

export const MobileRowStyled = {
  Container: styled.div<any>`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
    border: 3px solid ${Colors.Primary};
    border-radius: 10px;
    padding: 2rem;
    margin: 2rem 1rem;
  `,
  MobileRowInfo: styled.div<any>`
     display: flex;
     flex-direction: column;
     width: 70%;
  `,
  RowLabel: styled.h3<any>`
    color: ${Colors.Primary};
    font-size: 1.2rem;
    border-bottom: 3px solid ${Colors.GreyLine};
    margin-top: 1rem;
    padding-bottom: .3rem;
  `,
  MobileRowActions: styled.div<any>`
    margin: -2rem -2rem 0 0;
    right: 0;
    display: flex;
  `,
  Interval: styled.div<any>`
    border-bottom: 1px solid ${Colors.GreyLine};
    margin: .5rem 0;
  `,
  IntervalName: styled.p<any>`
    color: ${Colors.Primary};
    font-size: 1rem;
  `
};